
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EtiquettePilotageModel } from 'src/models/pilotage/etiquettePilotageModel';
import { UtilisateurListPilotageModel } from 'src/models/pilotage/utilisateurListPilotageModel';
import { EtiquetteService } from 'src/services/etiquette.service';

@Component({
    selector: 'app-show-utilisateurs-etiquette-dialog',
    templateUrl: './show-utilisateurs-etiquette-dialog.component.html',
    styleUrls: ['./show-utilisateurs-etiquette-dialog.component.scss'],
    imports: [
    FormsModule,
    TranslateModule,
    MatProgressSpinnerModule
]
})
export class ShowUtilisateursEtiquetteDialogComponent implements OnInit {
  etiquette!: EtiquettePilotageModel;
  utilisateurs: UtilisateurListPilotageModel[] = [];
  isLoading: boolean = false;

  get utilisateursActifs(): UtilisateurListPilotageModel[] {
    return this.utilisateurs.filter(u => u.estActif);
  }

  get utilisateursInactifs(): UtilisateurListPilotageModel[] {
    return this.utilisateurs.filter(u => !u.estActif);
  }

  constructor(
    public dialogRef: MatDialogRef<ShowUtilisateursEtiquetteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { etiquette: EtiquettePilotageModel, utilisateurs?: UtilisateurListPilotageModel[] },
    private etiquetteService: EtiquetteService,
    private translateService: TranslateService
  ) {
    this.etiquette = data.etiquette;
    this.utilisateurs = data.utilisateurs || [];
  }

  ngOnInit() {
    this.loadUtilisateurs();
  }

  private loadUtilisateurs(): void {
    this.isLoading = true;
    this.etiquetteService.obtenirUtilisateursParEtiquette(this.etiquette.etiquetteId).subscribe(
      (utilisateurs) => {
        this.utilisateurs = utilisateurs.sort((a, b) => a.nom.localeCompare(b.nom));
        this.isLoading = false;
      },
      (error) => {
        console.error('Error loading users for tag:', error);
        this.utilisateurs = [];
        this.isLoading = false;
      }
    );
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  getNomLocalise(locales: { [key: string]: string }): string {
    return this.etiquetteService.getNomLocalise(locales);
  }

  obtenirCouleur(hexColor: string): string {
    return this.etiquetteService.obtenirCouleur(hexColor);
  }
}